import axios from "axios";
import { BACKEND_API_ENDPOINT } from '../../constants/default';

const backendApi = axios.create({
  baseURL: BACKEND_API_ENDPOINT,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getLocationData = async (locationCode) => {
  if (!locationCode) return null;
  const res = await backendApi.get(`/getLocation?locationCode=${encodeURIComponent(locationCode)}`);
  return res.data;
};